import { useSyncExternalStore } from "react";

import { useCurrentAccount } from "@/providers/account";

import { getSignedInAccountId, subscribeToSignIn } from "./signInToFirebase";

/** Whether Firebase is signed in for the current account; a token for another account does not count. */
export function useIsSignedIn() {
  const accountId = useCurrentAccount().id;
  return (
    useSyncExternalStore(subscribeToSignIn, getSignedInAccountId) === accountId
  );
}
